export default __webpack_public_path__ + "static/media/news.2fd4d73c.jpeg";